import React from "react";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {Row} from "reactstrap";

const Alert = (props) => {
  return (
    <ReactBSAlert
      type={props.type}
      title={props.title}
      onConfirm={() => props.closeAlert()}
      onCancel={() => props.closeAlert()}
      confirmBtnBsStyle={props.type}
      confirmBtnText={props.confirmBtnText}
    >
      <Row className="justify-content-center mb-2 ml-1 mr-1">
        {props.description}
      </Row>
    </ReactBSAlert>
  );
};

export default Alert;
